var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65956 14.7543C11.4264 14.4444 13.6439 12.2326 13.9594 9.46571C14.3736 5.84794 11.5617 2.76833 8.03688 2.72888V1.10596C8.03688 1.01579 7.92418 0.967894 7.8481 1.02425L4.50646 3.47836C4.4501 3.52062 4.4501 3.60233 4.50646 3.64459L7.8481 6.0987C7.92418 6.15505 8.03688 6.10434 8.03688 6.01699V4.39689C10.5135 4.43633 12.4971 6.54388 12.3281 9.06279C12.1844 11.2295 10.4177 12.9877 8.25102 13.1257C5.95469 13.2723 4.00211 11.6324 3.65273 9.46289C3.58793 9.05998 3.23573 8.76695 2.83 8.76695C2.32565 8.76695 1.93119 9.21494 2.01008 9.71365C2.50034 12.8045 5.35455 15.1234 8.65956 14.7543Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.561f7bc76de26d6f8cd2a2ebca8daf51.svg";
export { ForwardRef as ReactComponent };